import { render, staticRenderFns } from "./search-placeholder.vue?vue&type=template&id=59ea4d30&scoped=true"
import script from "./search-placeholder.vue?vue&type=script&lang=js"
export * from "./search-placeholder.vue?vue&type=script&lang=js"
import style0 from "./search-placeholder.vue?vue&type=style&index=0&id=59ea4d30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ea4d30",
  null
  
)

export default component.exports